import * as React from 'react';

import { cn } from '@ui/lib/utils';

/** A field label, with the asterisk that says the field has to be answered. */
function Label({
  className,
  required,
  requiredLabel = 'required',
  children,
  ...props
}: React.ComponentProps<'label'> & { required?: boolean; requiredLabel?: string }) {
  return (
    // Radix/shadcn: callers must set `htmlFor` (or wrap an input) — association is not intrinsic here
    // eslint-disable-next-line jsx-a11y/label-has-associated-control -- design-system primitive
    <label
      data-slot="label"
      className={cn(
        'flex items-center gap-2 text-sm leading-none font-medium select-none group-data-[disabled=true]:pointer-events-none group-data-[disabled=true]:opacity-50 peer-disabled:cursor-not-allowed peer-disabled:opacity-50',
        className,
      )}
      {...props}
    >
      {children}
      {/* No gap of its own: the label's `gap-2` is a word's worth of space, and a star that far from
          what it marks reads as belonging to whatever is next along the row. */}
      {required ? (
        <>
          <span aria-hidden className="-ml-1.5 text-destructive">
            *
          </span>
          <span className="sr-only">{requiredLabel}</span>
        </>
      ) : null}
    </label>
  );
}

export { Label };
